
const trimStr = (str: string, trim: string) => {

  const firstNonTrimIdx = str.split('').findIndex(c => c !== trim);
  const lastNonTrimIdx = str.length - str.split('').reverse().findIndex(c => c !== trim);
  return str.substring(firstNonTrimIdx, lastNonTrimIdx);

}

const joinUrls = (...urlParts: string[]) => {

  return urlParts
    .map((urlPart) => trimStr(urlPart, '/'))
    .join('/')
}

export default joinUrls;
